import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=318c0eea&scoped=true&"
import script from "./modify.vue?vue&type=script&lang=js&"
export * from "./modify.vue?vue&type=script&lang=js&"
import style0 from "./modify.vue?vue&type=style&index=0&id=318c0eea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c0eea",
  null
  
)

export default component.exports